import React, {useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Employees.scss";
import EmployeeTemplate from "./EmployeeTemplate";
import NewEmployee from "./NewEmployee";
import MerchantEmployeeTemplate from "./MerchantEmployeesTemplate";
import Settings from "./Settings";

function Employees() {

    const [activeButton, setActiveButton] = useState({name: "Employees"});

    const handleButtonClick = (event) => {
        setActiveButton({name: event.target.innerText});
    };


    return (
        <>
            <HeaderComponent title="Employees"/>
            <div className="EmployeesPage">
                <div className="container-fluid Employeescontainer">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Employees" ? "active" : ""}`}
                                        onClick={handleButtonClick}>Employees
                                </button>
                                {(sessionStorage.getItem("EntityRole") === "SUPERADMIN" || (sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE" && sessionStorage.getItem("EntityRole") !== "Supervisor")) &&
                                    (
                                        <button
                                            className={`navButton ${activeButton.name === "+ New Employee" ? "active" : ""}`}
                                            onClick={handleButtonClick}
                                        >+ New Employee</button>
                                    )
                                }
                                {(sessionStorage.getItem("EntityType") === "LEGALENTITY" && (sessionStorage.getItem("EntityRole") === "SUPERADMIN" || sessionStorage.getItem("EntityRole") === "ADMIN")) &&
                                    (
                                        <button
                                            className={`navButton ${activeButton.name === "Settings" ? "active" : ""}`}
                                            onClick={handleButtonClick}
                                        >Settings</button>
                                    )
                                }
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>

                    <div className="row">

                        {(activeButton.name === "Employees" && sessionStorage.getItem("EntityType") === "LEGALENTITY") &&
                            <EmployeeTemplate setActiveButton={setActiveButton}/>}
                        {(activeButton.name === "Employees" && sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE") &&
                            <MerchantEmployeeTemplate setActiveButton={setActiveButton}/>}

                        {activeButton.name === "+ New Employee" && <NewEmployee setActiveButton={setActiveButton}/>}
                        {activeButton.name === "Settings" && <Settings activeButton={activeButton} setActiveButton={setActiveButton}/>}
                    </div>
                </div>
            </div>

        </>
    );
}

export default Employees;